import { render } from "./index.vue?vue&type=template&id=4676fdb6&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=4676fdb6&lang=less&scoped=true"

import exportComponent from "/Users/aa/work/credit_chakra_ios/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4676fdb6"]])

export default __exports__